import { Box } from "@mui/material";
import { SuccessBadge } from "src/components/FreeboardingBadge";
import { FreeboardingParagraph } from "src/components/FreeboardingParagraph";
import { FreeboardingSubtitle } from "src/components/FreeboardingSubtitle";
import { FreeboardingTitle } from "src/components/FreeboardingTitle";
import OutlinedCard from "src/components/OutlinedCard";
import { TargetIcon } from "src/components/TargetIcon";
import TeamNameInputField from "src/components/TeamNameInputField";
import { trainwellColor } from "src/theme/themePrimitives";

interface TeamNamePageProps {
  chipText: string;
  titleText: string;
  bodyText: string;
}

const TeamNamePageComponent = ({
  chipText,
  titleText,
  bodyText,
}: TeamNamePageProps) => {
  return (
    <Box
      display="flex"
      maxWidth="420px"
      flexDirection="column"
      width="100%"
      height="100%"
      justifyContent="space-between"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
      >
        <SuccessBadge label={chipText} />
        <FreeboardingTitle>{titleText}</FreeboardingTitle>
        <FreeboardingParagraph>{bodyText}</FreeboardingParagraph>

        <FreeboardingSubtitle sx={{ alignSelf: "flex-start" }}>
          Team name
        </FreeboardingSubtitle>
        <TeamNameInputField />
      </Box>

      <Box sx={{ marginTop: 2, marginBottom: 2 }}>
        <OutlinedCard
          text="Team names show throughout your trainwell journey! Keep it friendly,
           unique, and meaningful to your group. No special characters or offensive
           terms, please."
          icon={<TargetIcon />}
          cardColor={trainwellColor.success1}
          borderColor={trainwellColor.success3}
        />
      </Box>
    </Box>
  );
};

export default TeamNamePageComponent;
